module.exports = __webpack_public_path__ + "static/img/p1.2264863.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/service/parkServices/p1.jpg
// module id = cHNm
// module chunks = 1